import { Component, forwardRef, Input, Optional, Host, SkipSelf, Inject, Output, EventEmitter, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlContainer } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CultureInfo, CultureService, defaultCultureConfiguration } from 'app/common/services/culture.service';
import { BaseComponent } from '../../base.component';
import { AuthService } from 'app/auth-core/auth.service';
import { iconUserAvatar } from 'app/common/utils/icons.utils';

@Component({
	selector: 'user-avatar',
	templateUrl: './user-avatar.component.html',
	styleUrls: ["./user-avatar.component.scss"]
})

export class UserAvatarComponent extends BaseComponent implements OnInit {
	logged: boolean = false;
	iconUserAvatar = iconUserAvatar;
	
	constructor(private _cultureService: CultureService, private _authService: AuthService) {
		super();
	}

	
	ngOnInit(): void {
		this.on(this._authService.isAuthenticated$.subscribe((auth) => {
			this.logged = auth;
		}));
	}

	logout = () => {
		this._authService.logout();
	}

	login = () => {
		this._authService.login("/user-profile");
	}
}
